import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useSaveInvoiceMutation } from "state/api";

const FinalInvoice = ({ data, setLoader }) => {
  const [saveInvoice] = useSaveInvoiceMutation();

  const formik = useFormik({
    initialValues: {
      invoiceDate:
        new Date().toISOString().slice(0, 11) +
        new Date().toLocaleTimeString().slice(0, 5),
    },
    onSubmit: (values) => {
      values.transactionId = data._id;
      setLoader(true);
      saveInvoice(values)
        .unwrap()
        .then((res) => {
          alert("Invoice Saved");
          setLoader(false);
          window.location.reload();
        })
        .catch((err) => {
          alert("Invoice Failed");
          setLoader(false);
        });
    },
  });

  return (
    <>
      <div className="my-2 text-lg font-bold text-gray-700">Invoice</div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <TextField
            id="invoiceDate"
            name="invoiceDate"
            label="Invoice Date Time"
            type="datetime-local"
            value={formik.values.invoiceDate}
            onChange={formik.handleChange}
            
            fullWidth
          />

          <Button
            type="submit"
            className="my-2 bg-slate-600 hover:bg-slate-700 text-white w-24"
          >
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default FinalInvoice;
